import React from 'react';
import { Link } from 'react-router-dom';
import { WaterbodyImg } from '../waterbody_img/waterbody_img';
import { OmniaUrls } from '../../lib/urls';
import { Brand, Waterbody } from '@omniafishing/core';
import styles from './livestream_lake_blurb.less';

export const LivestreamLakeBlurb = ({
  waterbodies,
  brand,
}: {
  waterbodies: Waterbody[];
  brand: Brand;
}) => {
  return (
    <>
      <div className={styles.lakesBrand}>
        <div className={styles.lakesList}>
          {waterbodies.map((w) => (
            <Link to={OmniaUrls.waterbody(w)} className={styles.lake} key={w.id}>
              <WaterbodyImg
                waterbody={w}
                width={50}
                size={{
                  width: 100,
                  height: 80,
                  padding: 10,
                }}
              />
              {w.primary_name}
            </Link>
          ))}
        </div>
        {brand && (
          <div className={styles.presentedBy}>
            <span>Presented by </span> <img src={brand.image} alt={brand.display_name} />
          </div>
        )}
      </div>
    </>
  );
};
